
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-disclaimer",
      function () {
        return require("private-next-pages/email-disclaimer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-disclaimer"])
      });
    }
  